<template>
  <div class="game-card" @mouseenter="isHover = true" @mouseleave="isHover = false">
    <div class="card-inner" :class="{ 'is-flipped': isHover }">
      <!-- 正面 -->
      <div class="card-face front">
        <img :src="game.thumbnail" :alt="game.title">
        <h3>{{ game.title }}</h3>
      </div>
      
      <!-- 背面 -->
      <div class="card-face back">
        <p class="description">{{ game.description }}</p>
        <div class="buttons">
          <button @click="$emit('show-detail')" class="btn detail">Details</button>
          <button @click="$emit('play-game')" class="btn play">Play Now</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  game: {
    type: Object,
    required: true
  }
})

const isHover = ref(false)

defineEmits(['show-detail', 'play-game'])
</script>

<style scoped>
.game-card {
  width: 100%;
  height: 320px;
  perspective: 1000px;
  cursor: pointer;
}

.card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.card-inner.is-flipped {
  transform: rotateY(180deg);
}

.card-face {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  overflow: hidden;
}

.front {
  background: #fff;
}

.front img {
  width: 100%;
  height: 65%;
  object-fit: cover;
}

.front h3 {
  margin: 15px 10px;
  color: #333;
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.back {
  background: #E6E6FA;
  transform: rotateY(180deg);
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.description {
  color: #666;
  font-size: 13px;
  line-height: 1.4;
  max-height: 180px;
  overflow-y: auto;
  padding-right: 10px;
  margin-bottom: 15px;
  text-align: left;
}

.description::-webkit-scrollbar {
  width: 4px;
}

.description::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
}

.description::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}

.description::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.buttons {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: auto;
}

.btn {
  padding: 6px 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
  white-space: nowrap;
  font-size: 14px;
}

.btn.detail {
  background: #1E90FF;
  color: white;
}

.btn.play {
  background: #9370DB;
  color: white;
}

.btn:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}
</style> 